import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonUtility } from '@app/_modules/commonUtility';
import { CategoryService } from '@app/_services/category.service';
import { retryWhen } from 'rxjs/operators';

@Component({
  selector: 'app-fee-details',
  templateUrl: './fee-details.component.html'
})
export class FeeDetailsComponent implements OnInit {

  form: FormGroup;
  JSON;
  isgPay_url:string;
  todayDate:Date;

  @ViewChild('txnForm') txnForm: any;
  tranxnForm : FormGroup;
  submitBtnMsg:String;
  submitBtnMsgClass:String = 'wrappper';
  commonUtility:CommonUtility;
  loading = false;
  name:any='';
  fathersName:any='';
  courseLoader = false;
  course:any;
  semester:any;
  semesterList:any;
  source:any;
  type:any='';
  row:any='';
  disableSelect;
  totalFees:any;
  EncDataField:string;
  MerchantIdField:string;
  TransactionId:string;
  BankIdField:string;
  TerminalIdField:string;
  VersionField:string;
  myDIV: Boolean = false ;
  totalDisabled:boolean=true;
  console=console;

  coursesList: string[] = ['SQL','PL/SQL,ORACLE DBA', 'ORACEL RCA', 'Patching and Upgradation',
  'Perfomance tuning','Data guard','Golden Gtae','19C/21C new features','AWS' ,
  'MYSQL DBA','POSTGRESQL DBA','EXADATA' , 'Others'  ];

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private categoryService: CategoryService
  ) {
    this.JSON=JSON;
    this.isgPay_url = categoryService.isgPay_url;
    this.commonUtility = this.categoryService.commonUtility;

   }
   maxValue(event)
   {
    if(event.target.value && event.target.max)
    {
      if((event.which != 8 && event.which != 46 && event.which != 37 &&event.which != 39 &&event.which != 9))
      {
          if(event.target.value.length>(<number>event.target.max-1))
        {
          event.preventDefault();
        }
      }
    }
   }
  ngOnInit(): void {
   
    this.todayDate = new Date();
    
  this.tranxnForm = this.formBuilder.group({
    Version:[''],
    TerminalId: [''],
    BankId: [''],
    MerchantId: [''],
    EncData:[''],
    TransactionId:['']

         });
      this.form = this.formBuilder.group({
        studentName: ["",[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]],
        emailId: ["",[Validators.required,Validators.pattern("^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$")]],
        //mobileNo: ["",[Validators.required,Validators.pattern("^[0-9]*$"), Validators.minLength(10),Validators.maxLength(10)]],
        mobileNo: ["",[Validators.required,Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
        course: ["",[Validators.required]],
        address1: [""],
        address2: [""],  
        pincode : ["",[Validators.pattern("^[0-9]*$")]],
        country : ["",[Validators.pattern("^[a-zA-Z ]+$")]],
        feeAmount : ["",[Validators.pattern("^[0-9]*$")]]  
      });
  }
  

  get f()
 { return this.form.controls; }

  Submit():void{

    if (this.form.invalid ) {
      return;
    }
    console.log("course : "+this.form.controls.course.value);

    let req = {
      'studentName': this.form.controls.studentName.value,
      'emailId': this.form.controls.emailId.value,
      'mobileNo': this.form.controls.mobileNo.value,
      'course': this.form.controls.course.value?.toString(),
      'address1': this.form.controls.address1.value,
      'address2': this.form.controls.address2.value,
      'pincode': this.form.controls.pincode.value,
      'country': this.form.controls.country.value,
      'feeAmount' : this.form.controls.feeAmount.value,
      'source': 'ALOK', 
    }


    console.log("req : ");
    this.categoryService.submitAlokDetails(req).subscribe(res =>  {
      if(res.body.statusCode === "00000")
      {
       this.tranxnForm.controls.EncData.setValue(res.body.data.fields.EncData);
       this.tranxnForm.controls.MerchantId.setValue(res.body.data.fields.MerchantId);
       this.tranxnForm.controls.BankId.setValue(res.body.data.fields.BankId);
       this.tranxnForm.controls.TerminalId.setValue(res.body.data.fields.TerminalId);
       this.tranxnForm.controls.Version.setValue(res.body.data.fields.Version);
       this.tranxnForm.controls.TransactionId.setValue(res.body.data.fields.TransactionId);

       this.EncDataField  	= res.body.data.fields.EncData;
       this.MerchantIdField = res.body.data.fields.MerchantId;
       this.BankIdField = res.body.data.fields.BankId;
       this.TerminalIdField = res.body.data.fields.TerminalId ;
       this.VersionField = res.body.data.fields.Version ;
       this.txnForm.nativeElement.submit();


      }
      else{
       this.commonUtility.alertMsg(res.body.statusDesc,'',false);
      }
       this.loading = false;
            },(error)=>{  this.commonUtility.alertMsg(JSON.stringify(error.statusText) ,'',false);}
      )
     }



     



  onSubmit(): void
{

}
hideError(controlName:any)
    {
      this.form.controls[controlName].markAsUntouched();
      if(this.submitBtnMsgClass && this.submitBtnMsgClass.indexOf("alertBlock")>-1)
      {  this.submitBtnMsgClass="wrapper"; }
      if(this.submitBtnMsg && this.submitBtnMsg.indexOf("a")>-1)
      { this.submitBtnMsg=""; }

    }



}
